import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/property-sales.png'

const PropertySales = dynamic(() => import('src/components/insights/property-records/property-sales'), { ssr: false })

export const PropertySalesWidget: InsightBuilderWidget = {
  id: 'property-sales',
  name: 'Property Sales',
  component: PropertySales,
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
